// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
// Components
import OMLabelNew from '../../OMLabelNew/OMLabelNew';
import OMLabelTop from '../../OMLabelTop/OMLabelTop';
import CellInfoIconsBlock from '../components/CellInfoIconsBlock/CellInfoIconsBlock';
// Helpers
import parkingConverter from '../../../../utils/parkingConverter';
import displayPrice from '../../../../helpers/displayPrice';
import { ENTITY_TYPES } from '../../../../constants';
// Styles
import * as styles from './OMBaseMultiPinCell.scss';
import thumbnailPic from '../../../../../static/images/images_placeholder.svg';
import modifyImageLink from '../../../../utils/modifyImageLink';

class OMBaseMultiPinCell extends Component {
  shouldComponentUpdate(newProps) {
    const isIdChanged = (newProps.id !== this.props.id);
    const isLocaleChanged = (newProps.locale !== this.props.locale);

    return (isIdChanged || isLocaleChanged);
  }

  renderLabelNew = () => this.props.isNewProperty && (
    <div className={styles.labelNew}>
      <OMLabelNew
        label={this.props.newPropertyLabel.toString()}
        title={this.props.newPropertyTitle.toString()}
        isMobile={this.props.isMobile}
      />
    </div>
  );

  renderLabelTop = () => this.props.isTopPromotedProperty && (
    <div className={styles.labelNew}>
      <OMLabelTop
        label="TOP"
        isMobile={this.props.isMobile}
      />
    </div>
  );

  renderPrice = () => {
    const isProject = this.props.propertyEntityType === ENTITY_TYPES.PROJECT;
    return displayPrice(this.props, styles, isProject);
  };

  renderVRIcon = (hasVRLink) => hasVRLink && (
    <span className={cx(styles.labelVR, 'icon', 'icon-vr-view')}>
      <span className="path1" />
      <span className="path2" />
      <span className="path3" />
      <span className="path4" />
      <span className="path5" />
    </span>
  );

  render() {
    const parkingSpots = parkingConverter(this.props.parkingSpots);
    const groundFloor = +this.props.floor === 0;
    const isProject = this.props.propertyEntityType === ENTITY_TYPES.PROJECT;
    const image = (isProject ? modifyImageLink(this.props.photo) : this.props.photo) || thumbnailPic;

    return (
      <div className={styles.propertyRow}>
        {!isProject && <div className={styles.iconsWrapper}>
          {this.renderVRIcon(this.props.hasVRLink)}
          {this.renderLabelNew()}
          {this.renderLabelTop()}
        </div>}

        <div className={styles.image}>
          <img src={image} alt="" />
        </div>

        <div className={styles.propertyDescription}>
          <div className={styles.propertyType}>
            {isProject ? this.props.translate('header', 'projects') : this.props.propertyType}
          </div>

          <div className={styles.propertyPrice}>
            <div>{this.renderPrice()}</div>
          </div>

          <CellInfoIconsBlock
            locale={this.props.locale}
            area={this.props.area}
            floor={(groundFloor) ? this.props.groundFloorTitle.toString() : this.props.floor}
            floorIconTitle={this.props.floorIconTitle}
            parkingIconTitle={this.props.parkingIconTitle}
            parkingSpots={parkingSpots}
            rooms={this.props.rooms}
            roomsIconTitle={this.props.roomsIconTitle}
            squareIconTitle={this.props.squareIconTitle}
            status={this.props.status}
            translate={this.props.translate}
          />
        </div>
      </div>
    );
  }
}

OMBaseMultiPinCell.propTypes = {
  locale: PropTypes.string,
  isMobile: PropTypes.bool,
  isRtl: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
  propertyType: PropTypes.string,
  photo: PropTypes.string,
  price: PropTypes.number,
  address: PropTypes.string,
  rooms: PropTypes.number,
  parkingSpots: PropTypes.object,
  city: PropTypes.string,
  area: PropTypes.number,
  floor: PropTypes.number,
  isFavorite: PropTypes.bool,
  isNewProperty: PropTypes.bool,
  hasVRLink: PropTypes.bool,
  propertyNote: PropTypes.string,
  parkingIconTitle: PropTypes.func,
  roomsIconTitle: PropTypes.func,
  floorIconTitle: PropTypes.func,
  squareIconTitle: PropTypes.func,
  groundFloorTitle: PropTypes.func,
  newPropertyTitle: PropTypes.func,
  newPropertyLabel: PropTypes.func,
  addPropertyNote: PropTypes.func,
  toggleFavorite: PropTypes.func,
  status: PropTypes.string,
  translate: PropTypes.func,
  propertyEntityType: PropTypes.string,
  searchOption: PropTypes.string,
  isTopPromotedProperty: PropTypes.bool
};

export default OMBaseMultiPinCell;
